import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnInit,
  Inject
} from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { FlowsLaunchDarklyFeatureFlags, FlowsLaunchDarklyService, LAUNCH_DARKLY_SERVICE } from '@sondermind/launch-darkly';
import { FlowResponse, StepItem } from '@sondermind/utilities/models-flows';

@Component({
  selector: 'flows-intake-hero',
  templateUrl: './intake-hero.component.html',
  styleUrls: [
    './intake-hero.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntakeHeroComponent implements OnInit {
  @Input() component: StepItem;
  @Input() response: FlowResponse;

  overrideReasonDetail$: Observable<boolean> = of(true);

  showOptionalTextSlugs = new Set<string>([
    'desired-availability'
  ]);

  constructor(
    @Inject(LAUNCH_DARKLY_SERVICE)
    private launchDarklyService: FlowsLaunchDarklyService,
  ) {}

  ngOnInit(): void {
    this.overrideReasonDetail$ = this.launchDarklyService.ldFlag$.pipe(
      map((ldFlags) => {
        const removeInPersonFlag = ldFlags[FlowsLaunchDarklyFeatureFlags.REMOVE_IN_PERSON] as boolean;
        const isCorrectFlowAndStep = this.response.slug === 'matching-flow-base'
          && this.component.slug === 'reasonDetail';

        return removeInPersonFlag && isCorrectFlowAndStep;
      })
    );
  }
}
